import { render, staticRenderFns } from "./BBDropdown.vue?vue&type=template&id=4c0fef5d&"
import script from "./BBDropdown.vue?vue&type=script&lang=js&"
export * from "./BBDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports